const validatePortugueseIdCard = (id: string): boolean => {
  const PT_ID_CARD_REGEX = /^\d{8}(\d[A-Z]{2}\d)?$/

  const normalizedId = id.toUpperCase().replace(/\s/g, '')

  if (!normalizedId || normalizedId.length === 0) {
    return false
  }

  return PT_ID_CARD_REGEX.test(normalizedId)
}

export default validatePortugueseIdCard
